import { DashboardWidget } from "./DashboardWidget";
import { BarChart3, TrendingUp, Table2, DollarSign, MousePointerClick, Eye, Target, ShoppingCart, Users, Repeat, Megaphone, Hash } from "lucide-react";

const ICON_MAP: Record<string, React.ElementType> = {
  "kpi-spend": DollarSign,
  "kpi-impressions": Eye,
  "kpi-clicks": MousePointerClick,
  "kpi-ctr": Target,
  "kpi-cpc": DollarSign,
  "kpi-cpm": DollarSign,
  "kpi-roas": TrendingUp,
  "kpi-purchases": ShoppingCart,
  "kpi-revenue": DollarSign,
  "kpi-reach": Users,
  "kpi-leads": Megaphone,
  "kpi-frequency": Repeat,
};

interface WidgetPlaceholderProps {
  widgetId: string;
  title: string;
  isEditMode: boolean;
  onRemove?: () => void;
  onResize?: () => void;
  onResetSize?: () => void;
}

export function WidgetPlaceholder({ widgetId, title, isEditMode, onRemove, onResize, onResetSize }: WidgetPlaceholderProps) {
  const Icon = ICON_MAP[widgetId] || (widgetId.startsWith("chart-") ? BarChart3 : widgetId.startsWith("table-") ? Table2 : Hash);

  return (
    <DashboardWidget
      title={title}
      isEditMode={isEditMode}
      onRemove={onRemove}
      onResize={onResize}
      onResetSize={onResetSize}
    >
      <div className="flex flex-col items-center justify-center h-full p-4 text-center">
        <Icon className="h-8 w-8 text-gray-300 mb-2" />
        <p className="text-xs text-gray-400">Widget content coming soon</p>
        <p className="text-[10px] text-gray-300 mt-1">{widgetId}</p>
      </div>
    </DashboardWidget>
  );
}
